export default __webpack_public_path__ + "static/media/hey_sondn.8c2f8e9b.mp3";